module.exports = "<rnpl-form-wizard [formKey]=\"formKey\" [formLabel]=\"formLabel\" (closed)=\"back()\"></rnpl-form-wizard>\n"